'use client';

import { useEffect } from 'react';
// Rendered in the App Shell: next-intl's router reads the route params during render, which blocks
// the shell. window.location's path below keeps its locale prefix.
// eslint-disable-next-line no-restricted-imports -- see above
import { useRouter } from 'next/navigation';
import { useIsWTGamesApp } from '@/features/games-app-bridge/shared/hooks/use-is-wt-games-app';

type Props = {
  children?: React.ReactNode;
  removePlaySuffix?: boolean;
};

export default function GamesAppOnly({ children, removePlaySuffix }: Props) {
  const router = useRouter();
  const isWTGamesApp = useIsWTGamesApp();

  useEffect(() => {
    if (!isWTGamesApp) return;

    const path = window.location.pathname;

    if (removePlaySuffix) {
      const newPath = path.replace(/\/play$/, '');
      if (newPath !== path) {
        router.replace(newPath);
      }
    }
  }, [isWTGamesApp, removePlaySuffix, router]);

  return isWTGamesApp ? <>{children}</> : null;
}
